import styled from 'styled-components';

export const Page = styled.div`
  max-width: 1500px; margin: 0 auto;
  h1 { font-size: 1.8rem; letter-spacing: -0.035em; margin: 0 0 .5rem; }
  h2 { font-size: 1.2rem; margin: 0; }
  h3 { font-size: 1rem; }
  button:focus-visible, a:focus-visible, [contenteditable]:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.primary}; outline-offset: 3px;
  }
`;
export const Head = styled.div`
  display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem;
  flex-wrap: wrap; margin-bottom: 1.5rem;
  p { color: ${({ theme }) => theme.colors.text.secondary}; max-width: 64ch; }
`;
export const Grid = styled.div`
  display: grid; grid-template-columns: 310px minmax(0, 1fr); gap: 1.5rem; align-items: start;
  @media (max-width: 1180px) { grid-template-columns: 1fr; }
`;
export const Panel = styled.section`
  padding: 1.25rem; background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 12px;
  display: grid; gap: 1rem; min-width: 0;
`;
export const Stack = styled.div`display: grid; gap: 1rem; min-width: 0;`;
export const Row = styled.div`display: flex; flex-wrap: wrap; align-items: center; gap: .65rem;`;
export const Fields = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem;
  @media (max-width: 650px) { grid-template-columns: 1fr; }
`;
export const Field = styled.label`
  display: grid; gap: .4rem; min-width: 0; font-size: .9rem; font-weight: 600;
  input, select, textarea {
    width: 100%; min-width: 0; padding: .7rem .8rem; font: inherit; font-weight: 400;
    border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 6px;
    background: ${({ theme }) => theme.colors.surface}; color: ${({ theme }) => theme.colors.text.primary};
    &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.primary}; outline-offset: 2px; }
    &:disabled { opacity: .7; }
  }
  textarea { resize: vertical; }
  small { font-weight: 400; color: ${({ theme }) => theme.colors.text.secondary}; line-height: 1.5; }
`;
export const Note = styled.p<{ $warning?: boolean }>`
  margin: 0; padding: .8rem 1rem; border-radius: 6px; font-size: .9rem; line-height: 1.5;
  background: ${({ $warning, theme }) => $warning ? '#fff7e7' : theme.colors.primarySoft};
  color: ${({ $warning, theme }) => $warning ? '#744707' : theme.colors.text.primary};
  border-left: 3px solid ${({ $warning, theme }) => $warning ? '#c88517' : theme.colors.primary};
`;
export const Hint = styled.p`
  margin: 0; color: ${({ theme }) => theme.colors.text.secondary}; font-size: .875rem; line-height: 1.5;
`;
export const AgendaItem = styled.button<{ $active: boolean }>`
  display: grid; width: 100%; text-align: left; gap: .45rem; padding: .9rem;
  border: 1px solid ${({ $active, theme }) => $active ? theme.colors.primary : theme.colors.border};
  border-left: 3px solid ${({ $active, theme }) => $active ? theme.colors.primary : theme.colors.border};
  border-radius: 6px; color: ${({ theme }) => theme.colors.text.primary}; cursor: pointer;
  background: ${({ $active, theme }) => $active ? theme.colors.primarySoft : theme.colors.surface};
  strong { font-size: .95rem; line-height: 1.4; }
  small { color: ${({ theme }) => theme.colors.text.secondary}; }
  &:hover { border-color: ${({ theme }) => theme.colors.primary}; }
`;
export const Status = styled.span<{ $warning?: boolean }>`
  display: inline-block; width: fit-content; padding: .2rem .5rem; border-radius: 4px;
  font-size: .75rem; font-weight: 600;
  color: ${({ $warning, theme }) => $warning ? '#744707' : theme.colors.text.primary};
  background: ${({ $warning, theme }) => $warning ? '#fff0cd' : theme.colors.background};
`;
export const Preview = styled.article`
  overflow-wrap: anywhere; line-height: 1.8;
  h1 { font-size: 1.8rem; line-height: 1.3; }
  h2 { font-size: 1.35rem; margin: 1.5rem 0 .6rem; }
  h3 { font-size: 1.15rem; margin: 1.25rem 0 .5rem; }
  p, ul, ol { margin: .75rem 0; }
  ul, ol { padding-left: 1.5rem; }
  img { max-width: 100%; height: auto; border-radius: 6px; }
  a { color: ${({ theme }) => theme.colors.primary}; text-decoration: underline; }
`;
